<!-- 推送记录管理 -->
<template>
  <div class="page">
    <div
      class="paginations"
      :style="{ filter: this.$store.state.isVague ? 'blur(2px)' : '' }"
    >
      <div class="table-search-box table-search-box-hander">
        <el-form :inline="true" :model="searchData" class="demo-form-inline">
          <!-- 防止输入框回车刷新页面 -->
          <el-form-item label="" v-show="false">
            <el-input></el-input>
          </el-form-item>
          <el-form-item label="月份：">
            <el-date-picker
              v-model="searchData.month"
              type="month"
              value-format="yyyyMM"
              placeholder="请选择月份"
            />
          </el-form-item>
          <el-form-item label="级别：">
            <el-select size="small" placeholder="请选择" v-model="level">
              <el-option value="1" label="国家级" />
              <el-option value="2" label="省级" />
            </el-select>
          </el-form-item>
          <el-form-item label="资源库：">
            <el-select
              size="small"
              placeholder="请选择资源库"
              v-model="searchData.zykId"
              clearable
            >
              <el-option
                v-for="(item, index) in zykDataList"
                :key="index"
                :value="item.zykId"
                :label="item.zykName"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="是否处理：">
            <el-select
              size="small"
              placeholder="请选择"
              v-model="searchData.processFlag"
              clearable
            >
              <el-option value="是" label="是" />
              <el-option value="否" label="否" />
            </el-select>
          </el-form-item>
          <el-form-item label="数据类型：">
            <el-select
              size="small"
              placeholder="请选择数据类型"
              v-model="searchData.dataType"
              clearable
            >
              <el-option
                v-for="item in dataTypeList"
                :key="item.value"
                :value="item.value"
                :label="item.name"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="是否成功：">
            <el-select
              size="small"
              placeholder="请选择"
              v-model="searchData.successFlag"
              clearable
            >
              <el-option value="是" label="是" />
              <el-option value="否" label="否" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <div class="search_button">
              <i class="pointer el-icon-search" @click="search()"></i>
              <i class="pointer el-icon-refresh-left" @click="reset"></i>
              <div class="addition">
                <el-button @click="handleData(true)">处理</el-button>
                <el-button @click="resetHandle(true)">重置未处理</el-button>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <div class="table_box">
        <el-table
          :data="tableObj.list"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column prop="id" label="id" align="center" />
          <el-table-column prop="zykId" label="zykid" align="center" />
          <el-table-column prop="processTime" label="处理时间" align="center" />
          <el-table-column prop="uploadTime" label="上传时间" align="center" />
          <el-table-column
            prop="dataTypeName"
            label="数据类型"
            align="center"
          />
          <el-table-column
            prop="totalCount"
            label="总条数"
            width="70"
            align="center"
          />
          <el-table-column
            prop="insertCount"
            label="插入条数"
            width="80"
            align="center"
          />
          <el-table-column
            prop="updateCount"
            label="更新条数"
            width="80"
            align="center"
          />
          <el-table-column
            prop="failedCount"
            label="失败条数"
            width="80"
            align="center"
          />
          <el-table-column
            prop="code"
            label="是否成功"
            width="80"
            align="center"
          />
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <i
                class="icona el-icon-thumb"
                title="处理"
                @click="handleData(false, [scope.row.id])"
              />
              <i
                class="icona el-icon-refresh-left"
                title="重置未处理"
                @click="resetHandle(false, [scope.row.id])"
              />
            </template>
          </el-table-column>
        </el-table>
        <pageNumber
          :paginations="7"
          :pageNum="searchData.pageDto.pageNum"
          :page-size="searchData.pageDto.pageSize"
          :total="tableObj.total"
          :jumpTo="tableObj.jumpTo"
          @currentChange="search"
        ></pageNumber>
      </div>
    </div>
  </div>
</template>

<script>
import pageNumber from "@/components/pageNumber.vue"; //分页
export default {
  components: {
    pageNumber,
  },
  data() {
    return {
      // 查询条件
      searchData: {
        month: "",
        zykId: "",
        processFlag: "",
        dataType: 2,
        successFlag: "",
        pageDto: {
          pageNum: 1, //当前显示的页面页码数
          pageSize: 10,
        },
      },
      //数据类型
      dataTypeList: [
        {
          value: 2,
          name: "用户数据",
        },
        {
          value: 3,
          name: "课程数据",
        },
        {
          value: 4,
          name: "题库数据",
        },
        {
          value: 5,
          name: "资源数据",
        },
        {
          value: 6,
          name: "课程内容和活动实施信息",
        },
        {
          value: 7,
          name: "日志数据",
        },
        {
          value: 8,
          name: "试题数据",
        },
        {
          value: 9,
          name: "作业、测试和考试信息",
        },
        {
          value: 10,
          name: "作业、测试和考试引用试题关系表",
        },

        {
          value: 11,
          name: "论坛信息",
        },
        {
          value: 12,
          name: "开课",
        },
        {
          value: 13,
          name: "选课",
        },
        {
          value: 14,
          name: "课程公告",
        },
        {
          value: 15,
          name: "课程内容和活动部署信息",
        },
        {
          value: 16,
          name: "论坛帖子和回复信息",
        },
        {
          value: 17,
          name: "作业、测试和考试测评打分",
        },
        {
          value: 18,
          name: "课程学习成绩信息",
        },
      ],
      nowMonth: "",
      level: "1",
      zykDataList: [],
      // 表格数据
      tableObj: {
        total: 0,
        jumpTo: 1,
        list: [],
      },
      selectRowId: [],
    };
  },
  mounted() {
    // 创建一个 Date 对象
    let date = new Date();
    // 获取年、月、日、时、分、秒
    let year = date.getFullYear();
    let month = date.getMonth() + 1; // 月份是从 0 开始计数的，需要加1
    month = month < 10 ? "0" + month : month;
    this.nowMonth = `${year}${month}`;
    this.searchData.month = this.nowMonth;
    this.source(this.level);
    this.search();
  },
  watch: {
    level(val) {
      this.searchData.zykId = "";
      this.source(val);
    },
  },
  methods: {
    // 获取资源库
    source(value) {
      this.$axios
        .post(this.$apiurls.major_getAllZykList, value, { loading: false })
        .then((res) => {
          if (res.code === 200) this.zykDataList = res.data || [];
        });
    },
    // 查询表格
    search(page) {
      this.searchData.pageDto.pageNum = page ? page : 1;
      this.tableObj.jumpTo = page ? page : 1;
      this.$axios
        .post(this.$apiurls.getZykUpDataMonitorDb, this.searchData, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            let data = res.data.list;
            for (const item of data) {
              if (item.dataType)
                item.dataTypeName = this.dataTypeList.find(
                  (i) => i.value === item.dataType
                ).name;
            }
            this.tableObj.list = res.data.list;
            this.tableObj.total = res.data.total;
          }
        });
    },
    // 重置表格
    reset() {
      this.searchData.dataType = this.dataTypeList[0].value;
      this.searchData.month = this.nowMonth;
      this.searchData.zykId = "";
      this.searchData.processFlag = "";
      this.searchData.successFlag = "";
      this.level = "1";
      this.search();
    },
    // 表格多选
    handleSelectionChange(val) {
      let idArr = [];
      for (const item of val) {
        idArr.push(item.id);
      }
      this.selectRowId = idArr;
    },
    // 处理
    handleData(flag, id) {
      if (flag) {
        if (this.selectRowId.length === 0)
          return this.$message.warning({
            message: "请先选择要处理的行！",
          });
        id = this.selectRowId;
      }
      this.$axios
        .post(this.$apiurls.zykProcessData, id, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "处理成功！",
              type: "success",
            });
            this.search();
          }
        });
    },
    // 重置未处理
    resetHandle(flag, id) {
      if (flag) {
        if (this.selectRowId.length === 0)
          return this.$message.warning({
            message: "请先选择要重置未处理的行！",
          });
        id = this.selectRowId;
      }
      this.$axios
        .post(this.$apiurls.resetUnProcess, id, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "重置未处理成功！",
              type: "success",
            });
            this.search();
          }
        });
    },
  },
};
</script>

<style lang="scss" src="@/assets/css/popUp.scss" scoped>
</style>
<style lang="scss" src="@/assets/css/tableList.scss" scoped>
</style>
<style lang="scss" scoped>
.paginations {
  height: 100%;
}

::v-deep .el-form {
  height: 100%;

  .el-textarea {
    .el-textarea__inner {
      font-family: initial;
    }
  }
}

.pop_up ::v-deep .el-dialog__body {
  max-height: 600px;
}

.el-tree {
  max-height: 550px;
  overflow: auto;
}

.el-tree,
::v-deep.el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content,
::v-deep .el-tree-node:focus > .el-tree-node__content {
  background: transparent;
  color: #c0c4cc;
}

.el-tree ::v-deep .el-tree-node__content:hover {
  background: #203058 !important;
  color: #fff;
}

.table_box {
  // max-height: calc(100% - 60px);
  margin-bottom: 0;
}
</style>
<style lang="scss">
.zyk-content {
  width: calc(100% - 50px);
  margin-left: 20px;
  min-height: 100px;
  max-height: 200px;
  overflow: auto;
  border: 1px solid rgba(86, 94, 121, 0.59);
  background-color: rgba(86, 94, 121, 0.59);
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 15px;

  .item {
    margin-right: 20px;
    color: #fff;
  }
}

.el-select-dropdown {
  position: absolute;
  z-index: 1001;
  border: none !important;
  max-height: 268px;
  border-radius: 4px;
  background-color: rgba(26, 38, 72);
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  box-sizing: border-box;
  margin: 5px 0;

  .el-select-dropdown__list {
    box-sizing: border-box;
    padding: -1px 0;
    background: rgba(26, 38, 72) !important;

    .el-select-dropdown__item {
      color: #fff !important;
    }

    .hover,
    .el-select-dropdown__item:hover {
      background: transparent;
      border: 1px solid rgba(27, 246, 248);
    }

    .el-select-dropdown__item:hover span {
      font-size: 14px;
      transform: scale(1);
    }

    .selected {
      color: rgba(27, 246, 248);
    }
  }

  .popper__arrow,
  .popper__arrow::after {
    position: absolute;
    display: "";
    width: "";
    height: "";
    border: none;
    border-style: "";
  }
}

.el-input__inner {
  height: 32px;
  background: rgba(86, 94, 121, 0.59);
  border-color: rgba(86, 94, 121, 0.59);
  color: #fff;
}
.el-picker-panel {
  background-color: rgb(26, 38, 72);
  border: none;
}
.el-date-picker__header--bordered {
  border-color: #b4b3b3;
}
.el-popper .popper__arrow {
  display: none;
}
.el-month-table td .cell,
.el-date-picker__header-label,
.el-picker-panel__icon-btn {
  color: #fff;
}
.el-icon-thumb,
.el-icon-refresh-left {
  font-size: 18px !important;
  color: #1bf6f8 !important;
  margin-right: 5px;
  cursor: pointer;
  font-weight: bold;
}
</style>
